<template>
    <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="projects-lower-bar-button-path" d="M4.26654 2.1333C3.6772 2.1333 3.19987 2.61063 3.19987 3.19997V3.7333H12.7999C13.3892 3.7333 13.8665 4.21063 13.8665 4.79997V11.7333H14.3999C14.9892 11.7333 15.4665 11.256 15.4665 10.6666V3.19997C15.4665 2.61063 14.9892 2.1333 14.3999 2.1333H4.26654ZM1.59987 4.79997C1.01054 4.79997 0.533203 5.2773 0.533203 5.86663V12.8C0.533203 13.3893 1.01054 13.8666 1.59987 13.8666H11.7332C12.3225 13.8666 12.7999 13.3893 12.7999 12.8V5.86663C12.7999 5.2773 12.3225 4.79997 11.7332 4.79997H1.59987ZM6.39987 6.9333C6.69427 6.9333 6.9332 7.17223 6.9332 7.46663V9.06663H8.5332C8.8276 9.06663 9.06654 9.30557 9.06654 9.59997C9.06654 9.89437 8.8276 10.1333 8.5332 10.1333H6.9332V11.7333C6.9332 12.0277 6.69427 12.2666 6.39987 12.2666C6.10547 12.2666 5.86654 12.0277 5.86654 11.7333V10.1333H4.26654C3.97214 10.1333 3.7332 9.89437 3.7332 9.59997C3.7332 9.30557 3.97214 9.06663 4.26654 9.06663H5.86654V7.46663C5.86654 7.17223 6.10547 6.9333 6.39987 6.9333Z" fill="CurrentColor"/>
    </svg>
</template>

<script>
    export default {
        name: "SVGProjectsCopy"
    }
</script>

<style scoped>

</style>
